export default __webpack_public_path__ + "static/media/big_head_-5.06c3d71e.webp";